import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const LOGO_URL = "/logo.png";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0B1220] text-slate-300 border-t border-white/5" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img
              src={LOGO_URL}
              alt="ZEMKA"
              className="h-20 sm:h-24 w-auto"
              style={{ filter: 'invert(1) brightness(1.05)' }}
            />
            <p className="mt-5 max-w-md text-sm text-slate-400 leading-relaxed">{t.footer.tagline}</p>
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-400">{t.nav.contact}</div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone size={14} className="mt-1 text-cyan-400" />
                <a href="tel:01708251779" className="hover:text-white" data-testid="footer-phone">
                  0170 8251779
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 text-cyan-400" />
                <span>Sigmundstraße, 82377 Penzberg</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={14} className="mt-1 text-cyan-400" />
                <a href="mailto:zemka.gebaeudereinigung@gmail.com" className="hover:text-white break-all">
                  zemka.gebaeudereinigung@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-400">
              {t.contact.info.hoursTitle}
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li className="flex justify-between border-b border-white/10 pb-1.5">
                <span>{t.contact.info.hoursMonSat}</span>
                <span className="font-semibold text-white">{t.contact.info.hoursMonSatVal}</span>
              </li>
              <li className="flex justify-between">
                <span>{t.contact.info.hoursSun}</span>
                <span className="text-slate-500">{t.contact.info.hoursSunVal}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
          <div>
            © {year} ZEMKA Gebäudereinigung & Hausmeister Service · {t.footer.rights}
          </div>
          <div className="flex gap-5">
            <Link to="/impressum" className="hover:text-white" data-testid="footer-impressum-link">
              {t.footer.legal}
            </Link>
            <Link to="/datenschutz" className="hover:text-white" data-testid="footer-datenschutz-link">
              {t.footer.privacy}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
